import React, { useMemo } from 'react'

import { cn } from '../../../../utils'
import { StarIcon } from '../assets/Icon'

const SingleCurriculum = ({
  noOfCols = 3,
  data
}: {
  data: { heading: string; highlightedHeading: string; topics: string[] }
  noOfCols?: number
}) => {
  const divideTopicByColumn = useMemo(() => {
    const divide = Math.ceil(data.topics.length / noOfCols)
    const d = []
    for (let i = 0; i < noOfCols; i++) {
      d.push([...data.topics.slice(i * divide, (i + 1) * divide)])
    }
    return d
  }, [noOfCols, data.topics])

  return (
    <div className="bg-white/10 text-gray-50 rounded-2xl w-full max-w-4xl mx-auto p-8 sm:p-16">
      <div className="flex flex-col gap-8 sm:gap-12">
        <div className="text-2xl sm:text-3xl flex flex-col gap-4 sm:text-center">
          <p>{data.heading}</p>
          <p className="font-bold text-primary">{data.highlightedHeading}</p>
        </div>
        <div>
          <div className="flex flex-wrap justify-between gap-5">
            {divideTopicByColumn.map((col, idx) => (
              <div
                key={idx}
                className={cn(
                  'flex flex-col gap-5',
                  `sm:max-w-[${100 / noOfCols}%]`
                )}>
                {col.map((topic) => (
                  <div key={topic} className="flex flex-row gap-5">
                    <StarIcon />
                    <p>{topic}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleCurriculum
